import { Drawer } from "antd";
import { CloseIcon } from "icons";
import styles from "./index.module.css"
import PropTypes from "prop-types";

const CustomDrawer = ({ open, setOpen, title, children }) => {
    const onClose = () => {
        setOpen(false);
    };
    return (
        <Drawer
            className={styles.drawerWrapper}
            title={title}
            placement="bottom"
            closable={false}
            onClose={onClose}
            open={open}
            extra={
                <CloseIcon width={20} height={20} onClick={onClose} className="cursor-pointer" />
            }
        >
            {children}
        </Drawer>
    )
}

CustomDrawer.propTypes = {
    open: PropTypes.bool,
    setOpen: PropTypes.func,
    title: PropTypes.string,
    children: PropTypes.node
}

export default CustomDrawer
